// src/lib/thumbPriority.js — reorders (never re-shapes) the Desk's batch photo fetches.
//
// getListingThumbs/getPropertyThumbs answer their WHOLE id list in one round trip — cheap
// on the wire, but every card that batch covers goes from no-photo to photo at the exact
// same instant, because none of their <img> tags get a `src` until that ONE request
// resolves. On a full page (~30 cards) the agent waits for the SLOWEST photo in the batch
// before seeing the fastest, even though the first few cards are all that's on screen.
//
// Splitting the ids into a small PRIORITY slice — the cards actually above the fold — and
// firing that request first, then firing the rest only once it lands, lets the first
// screenful paint its photos as soon as its OWN (smaller, faster) request resolves, while
// the rest keep loading behind it. Same total requests and bytes either way; only the
// ORDER changes. 2026-08-10, owner: "load first image first, then continue in background."
export const THUMB_PRIORITY_COUNT = 8

// fetchFn(ids) -> Promise<{[id]: value}>. onBatch(map, ids) fires once per stage — `ids` is
// the slice THAT stage requested, not the whole list, so a caller can mark exactly those
// ids as resolved (including the ones absent from `map`, which means "no photos" rather
// than "not answered yet") without waiting for the second stage to also land.
export async function fetchPrioritized(ids, fetchFn, onBatch, priorityCount = THUMB_PRIORITY_COUNT) {
    if (!ids?.length) return
    const priority = ids.slice(0, priorityCount)
    const rest = ids.slice(priorityCount)
    const first = await fetchFn(priority).catch(() => ({}))
    onBatch(first, priority)
    if (!rest.length) return
    const second = await fetchFn(rest).catch(() => ({}))
    onBatch(second, rest)
}
